<template>
  <header class="header">
    <div class="container">
      <div class="header-inner">
        <!-- Logo -->
        <div class="logo">
          <div class="logo-image">
            <img src="../image/logo/logo.png" alt="Hair Hub Factory Logo" />
          </div>
          <a href="/">Hair Hub Factory</a>
        </div>

        <!-- 桌面端导航 -->
        <nav class="main-nav" v-show="!isMobileMenuOpen">
          <ul>
            <li>
              <router-link
                  :to="{ path: '/', hash: '#home' }"
                  active-class="active"
              >HOME</router-link
              >
            </li>
            <li>
              <router-link
                  :to="{ path: '/', hash: '#about' }"
                  active-class="active"
              >About Us</router-link
              >
            </li>
            <li>
              <router-link
                  :to="{ path: '/', hash: '#product' }"
                  active-class="active"
              >Product</router-link
              >
            </li>
            <li>
              <router-link
                  :to="{ path: '/', hash: '#creation' }"
                  active-class="active"
              >New Creation</router-link
              >
            </li>
            <li>
              <router-link
                  :to="{ path: '/', hash: '#contact' }"
                  active-class="active"
              >Contact</router-link
              >
            </li>
          </ul>
        </nav>

        <!-- 功能图标 -->
        <div class="header-icons">
<!--          <a href="#" class="icon"><i class="fa fa-search"></i></a>-->
<!--          <a href="#" class="icon"><i class="fa fa-user"></i></a>-->
<!--          <a href="#" class="icon"><i class="fa fa-heart"></i></a>-->
<!--          <a href="#" class="icon cart-icon">-->
<!--            <i class="fa fa-shopping-cart"></i>-->
<!--            <span class="cart-count">0</span>-->
<!--          </a>-->
        </div>

        <!-- 移动端菜单按钮 -->
        <button class="mobile-menu-btn" @click="toggleMobileMenu">
          <i class="fa" :class="isMobileMenuOpen ? 'fa-times' : 'fa-bars'"></i>
        </button>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <div class="mobile-menu" v-show="isMobileMenuOpen">
      <ul>
        <li>
          <router-link
            :to="{ path: '/', hash: '#home' }"
            @click="toggleMobileMenu"
            active-class="active"
            >HOME</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ path: '/', hash: '#about' }"
            @click="toggleMobileMenu"
            active-class="active"
            >About Us</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ path: '/', hash: '#product' }"
            @click="toggleMobileMenu"
            active-class="active"
            >Product</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ path: '/', hash: '#creation' }"
            @click="toggleMobileMenu"
            active-class="active"
            >New Creation</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ path: '/', hash: '#journal' }"
            @click="toggleMobileMenu"
            active-class="active"
            >JOURNAL</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ path: '/', hash: '#contact' }"
            @click="toggleMobileMenu"
            active-class="active"
            >CONTACT</router-link
          >
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  name: "NavigationComp",
  data() {
    return {
      isMobileMenuOpen: false,
    };
  },
  // 生命周期：监听窗口大小
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  // 合并所有方法，修复重复报错
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      document.body.style.overflow = this.isMobileMenuOpen ? "hidden" : "";
    },
    handleResize() {
      if (window.innerWidth > 992) {
        this.isMobileMenuOpen = false;
        document.body.style.overflow = "";
      }
    },
  },
};
</script>

<style scoped>
/* 基础样式：所有设备通用 */
.header {
  background-color: #000;
  color: #fff;
  padding: 0 0;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  height: 60px;
  box-sizing: border-box;
  box-sizing: border-box;
}

.container {
  width: 95%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
}

.header-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.logo {
  display: flex;
  align-items: center;
  gap: 10px;
}
.logo-image {
  width: 110px;
  height: 110px;
  margin-top: -25px;
  margin-bottom: -25px;
}
.logo-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  gap: 20px;
}

.logo a {
  font-size: 28px;
  font-weight: bold;
  text-decoration: none;
  color: #fff;
  white-space: nowrap;
}

/* 桌面端导航 */
.main-nav ul {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
  gap: 20px;
}

.main-nav ul li {
  margin: 0;
}

.main-nav ul li a {
  text-decoration: none;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.3s;
  white-space: nowrap;
}

.main-nav ul li a:hover,
.main-nav ul li a.active {
  color: #ccc;
}

/* 功能图标 */
.header-icons {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-right: 15px;
}

.header-icons .icon {
  color: #fff;
  font-size: 18px;
  text-decoration: none;
  transition: color 0.3s;
}

.header-icons .icon:hover {
  color: #ccc;
}

.cart-icon {
  position: relative;
}

.cart-count {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #fff;
  color: #000;
  font-size: 12px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

/* 移动端菜单按钮 */
.mobile-menu-btn {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 24px;
  display: none;
  cursor: pointer;
  padding: 5px;
  z-index: 1001;
}

/* 移动端菜单 */
.mobile-menu {
  background-color: #000;
  position: fixed;
  top: 100px;
  left: 0;
  width: 100%;
  padding: 20px 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 999;
  box-sizing: border-box;
}

.mobile-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-menu ul li {
  margin-bottom: 15px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-menu ul li a {
  text-decoration: none;
  color: #fff;
  font-size: 16px;
  display: block;
  padding: 5px 0;
}

.mobile-menu ul li a.active {
  color: #ccc;
}

/* ------------------------------
   响应式断点适配
------------------------------ */
@media (max-width: 992px) {
  .main-nav {
    display: none;
  }
  .mobile-menu-btn {
    display: block;
  }
  .logo a {
    font-size: 24px;
  }
  .header-icons {
    gap: 10px;
    margin-right: 10px;
  }
  .header-icons .icon {
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .header {
    padding: 10px 0;
  }
  .logo a {
    font-size: 20px;
  }
  .header-icons {
    display: none;
  }
  .mobile-menu {
    top: 60px;
    padding: 15px 10px;
  }
  .mobile-menu ul li {
    margin-bottom: 10px;
    padding: 6px 0;
  }
}

@media (max-width: 480px) {
  .container {
    width: 100%;
    padding: 0 10px;
  }
  .mobile-menu-btn {
    font-size: 20px;
  }
  .mobile-menu ul li a {
    font-size: 15px;
  }
}
</style>